import { apiIsomorphicFetchUserEnvironment } from '#/api/userEnvironment/apiFetchUserEnvironment';
import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { redirectRequireAuthentication } from '#/modules/auth/routing/redirect-require-authentication';
import type { orgDashboardIntegrateAtsLinksRoute } from '#/modules/orgDashboard/routing/org-select.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { IntegrateAtsLinksLoadable } from './IntegrateAtsLinksLoadable';

export async function loader({
  request,
  context,
}: HorizonAppRouteLoaderArgs<typeof orgDashboardIntegrateAtsLinksRoute>) {
  const [{ user }] = await Promise.all([
    apiIsomorphicFetchUserEnvironment({
      request,
      context,
    })(),
    IntegrateAtsLinksLoadable.load(),
  ]);

  if (!user) return redirectRequireAuthentication({ request });
}

export default function OrgDashboardIntegrateAtsLinksHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule
      title={
        /* TRANSLATORS: page to choose organization to see integrate ATS page */
        i18n('Integrate ATS')
      }
    >
      <IntegrateAtsLinksLoadable />
    </RouteModule>
  );
}
